const $window = $(window);

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

import {pageTop} from "../include/module";
pageTop();

import {faqToggle} from "../include/module";
faqToggle();

import {formCheck} from "../include/module";
formCheck();

import {headerToggle} from "../include/module";
headerToggle();

import {headerScroll} from "../include/module";
headerScroll();

// const scrollAnimation = () => {
//   let winScroll = $(window).scrollTop();
//   let winHeight = $(window).height();
//
//   // SNS
//   const $tgt = $('.fix-registration');
//   const $tgt2 = $('.fix-sns-btn');
//   let mainvisualHeight = $('.mainvisual').height();
//   let registrationNowPosition = $('.registration-now').offset().top;
//   if (winScroll > mainvisualHeight && winScroll < registrationNowPosition - winHeight) {
//     $tgt.addClass('is-fixed');
//   } else {
//     $tgt.removeClass('is-fixed');
//   }
//   if (winScroll > mainvisualHeight) {
//     $tgt2.addClass('is-fixed');
//   } else {
//     $tgt2.removeClass('is-fixed');
//   }
// };
$(window).on('scroll', function(){
  // scrollAnimation();
});

$(window).on('load' , function() {
  // swiperslider();
  setTimeout(function () {
    // scrollAnimation();
  }, 1800);
});

const controller = new ScrollMagic.Controller();
const targets = document.querySelectorAll(".js-scrollAnimation");
const targetsArray = Array.prototype.slice.call(targets); //Array
targetsArray.forEach(target => {
  //シーンを作成
  const scene = new ScrollMagic.Scene({
      triggerElement: target,
      triggerHook: .9
  })
  .setClassToggle(target, "is-animated")
  .addTo(controller);
});



// WEBPACK FOOTER //
// ./src/sc-ins/assets/js/index/script.js